module.exports = __webpack_public_path__ + "images/hotel-rfp-negotiations-form-input-screenshot-1.d5f4911.png";